<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <progress-components page="travelHistory"></progress-components>
      <v-form ref="form" class="mt-12">
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>感染の可能性_半年以内の渡航歴 </strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-radio-group
            v-model="travelHistory"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
          </v-radio-group>
        </v-card>
        <div v-show="hasTravelHistory">
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>感染の可能性_半年以内の渡航歴_出国日 </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-responsive
              class="mx-5"
              max-width="344"
            >
              <v-text-field
                v-model="departureDate"
                variant="underlined"
                type="date"
                :rules="[requiredIfNeeded(hasTravelHistory)]"
              ></v-text-field>
            </v-responsive>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>感染の可能性_半年以内の渡航歴_入国日 </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-responsive
              class="mx-5"
              max-width="344"
            >
              <v-text-field
                v-model="entryDate"
                variant="underlined"
                type="date"
                :rules="[requiredIfNeeded(hasTravelHistory)]"
              ></v-text-field>
            </v-responsive>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>感染の可能性_半年以内の渡航歴_渡航先</strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-responsive
              class="mx-5"
              max-width="344"
            >
              <v-text-field
                label="回答を入力"
                variant="underlined"
                :rules="[requiredIfNeeded(hasTravelHistory)]"
                v-model="destination"
              ></v-text-field>
            </v-responsive>
          </v-card>
        </div>
      </v-form>
    </v-container>
    <v-container>
      <v-row v-if="fromConfirm" justify="center" align-content="center" class="mb-6 btn-area">
        <v-btn
          dark
          color="doorAccentColor"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="clickedNext"
        >確認
        </v-btn>
      </v-row>
      <v-row v-else justify="center" align-content="center" class="mb-6">
        <v-btn
          dark
          color="#B0B6BA"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="toBack"
        >戻る
        </v-btn>
        <v-btn
          dark
          x-large min-width="362px"
          color="doorAccentColor"
          class="mb-4 mx-4 white--text"
          @click="clickedNext"
        >次へ
        </v-btn>
      </v-row>
    </v-container>
    <footer-components></footer-components>
  </v-main>
</template>

<script>
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/InterviewTitle.vue'
import ProgressComponents from '@/components/InterviewProgress.vue'
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useScreenOperation } from '@/func/useScreenOperation'
import { Logger } from 'aws-amplify'
import { useCrossSectional } from '@/const/form/useCrossSectional'
import { useFormValidator } from '@/func/useFormValidator'

const logger = new Logger('AdvanceFormTravelHistory');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents
  },
  setup() {
    logger.info('AdvanceFormTravelHistory')
    const { scrollToErrorPosition, scrollToTop, fromConfirmScreen, toTopIfNameNotEntered} = useScreenOperation()

    onMounted(() => {
      scrollToTop()
      toTopIfNameNotEntered()
    })
    const fromConfirm = computed(() => fromConfirmScreen())

    const form = ref(null)
    const { selectFlagIndicators } = useCrossSectional()
    const { required, requiredIfNeeded } = useFormValidator()

    const store = useStore()
    const travelHistory = computed({
      get: () => store.state.advanceInterview.travelHistory,
      set: (value) => store.dispatch('advanceInterview/setTravelHistory', value)
    })
    const departureDate = computed({
      get: () => store.state.advanceInterview.departureDate,
      set: (value) => store.dispatch('advanceInterview/setDepartureDate', value)
    })
    const entryDate = computed({
      get: () => store.state.advanceInterview.entryDate,
      set: (value) => store.dispatch('advanceInterview/setEntryDate', value)
    })
    const destination = computed({
      get: () => store.state.advanceInterview.destination,
      set: (value) => store.dispatch('advanceInterview/setDestination', value)
    })
    const hasTravelHistory = computed( () => travelHistory.value === '有')
    const router = useRouter()
    const toBack = () => router.go(-1)
    const clickedNext = async () => {
      const result = await form.value.validate()
      if (!result.valid) {
        scrollToErrorPosition()
        return
      }
      if (fromConfirm.value) {
        router.push('/interview/confirm')
      } else {
        router.push('/interview/contact')
      }
    }
    return {
      scrollToErrorPosition,
      toBack,
      clickedNext,
      form,
      travelHistory,
      departureDate,
      entryDate,
      destination,
      selectFlagIndicators,
      required,
      requiredIfNeeded,
      hasTravelHistory,
      fromConfirm
    }
  }
})


</script>

<style scoped>
.v-input :deep(.v-label) {
  color: rgba(0, 0, 0, .87) !important;
}
.v-card-title {
  white-space: inherit !important;
}

@media screen and (max-width: 960px) {
  .btn-area button{
    min-width: 55%!important;
  }
}
</style>
